export class RegisterModel {
  Uid: string;
  Username: string;
  Password: string;
  CompanyName: string;
  Name: string;
  VatNumber: string;
  Newsletter: boolean;
  IsConsultant: boolean;
  ParametrizationId: number;

  Country: string;
  State: string;
  ProvinceCode: string;
  PhoneNumber: string;
  countriesCode: number;

  constructor() {}
}
